import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { _ } from '/@/locale';

import Title from '/@/v3/components/title';

import styles from './styles.module.css';

@autobind
export default class FactorInfo extends Component {
    static propTypes = {
        features: PropTypes.object,
        id: PropTypes.string,
    };

    renderText(data, color) {
        return data.map((item, key) => {
            return (
                <Title size='md' bolder className={classNames(styles[`font-${color}`], styles.displayBlock)} key={key}>
                    {_(item)}
                </Title>
            );
        });
    }

    renderInfo(info) {
        const { name, type, moment, symptoms, damage, cultives, conditions, control, color } = info;
        const className = classNames(styles.contentInfo, styles[`background-${color}`]);
        return (
            <div className={className}>
                <Title size='md' bolder className={classNames(styles[`font-${color}`], styles.spaceFont)}>{`${_(
                    'Enfermedad: '
                )} ${_(name)}`}</Title>
                {type ? (
                    <Title size='md' bolder className={classNames(styles[`font-${color}`], styles.spaceFont)}>{`${_(
                        'Tipo: '
                    )} ${_(type)}`}</Title>
                ) : (
                    <Title size='md' bolder className={classNames(styles[`font-${color}`], styles.spaceFont)}>{`${_(
                        'Momento:'
                    )} ${_(moment)}`}</Title>
                )}
                {symptoms > damage ? (
                    <Title size='md' bolder className={classNames(styles[`font-${color}`], styles.spaceFont)}>
                        {_('Síntomas: ')} {this.renderText(symptoms, color)}
                    </Title>
                ) : (
                    <Title size='md' bolder className={classNames(styles[`font-${color}`], styles.spaceFont)}>
                        {_('Daño:')} {this.renderText(damage, color)}
                    </Title>
                )}
                {conditions > damage ? (
                    <Title size='md' bolder className={classNames(styles[`font-${color}`], styles.spaceFont)}>
                        {_('Condiciones ambientales: ')} {this.renderText(conditions, color)}
                    </Title>
                ) : (
                    ''
                )}
                <Title size='md' bolder className={classNames(styles[`font-${color}`], styles.spaceFont)}>{`${_(
                    'Cultivos: '
                )} ${_(cultives)}`}</Title>
                <Title size='md' bolder className={classNames(styles[`font-${color}`], styles.spaceFont)}>{`${_(
                    'Control: '
                )} ${_(control)}`}</Title>
            </div>
        );
    }

    renderImages(info) {
        const images = info.images;
        return images.map((img, key) => {
            const className = classNames(styles.image, styles[`images-${img}`]);
            return <div className={className} key={key} />;
        });
    }

    render() {
        return (
            <div className={styles.root}>
                <div className={styles[`content-${this.props.side}`]}>
                    <div className={styles.images}>{this.renderImages(this.props.features)}</div>
                    {this.renderInfo(this.props.features)}
                </div>
                {this.props.children}
            </div>
        );
    }
}
